module.exports = __webpack_public_path__ + "static/x57-f30bbe38e8993ca8df630cc06cf318dd.png";